query GetAllCustomers {
  customers
}
